import React from "react";
import { Modal, Form, Button, message } from "antd";
import RichEditor from "@/components/display/richEditor";
import { addFirmware } from "@/fetch/fetchApi";
import UploadGeneral from "@/components/display/upload/uploadGeneral";
import fetchHandler from "@/fetch/fetchHandler";

const fileNameJsonParmas = {};
class UploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;
    this.setState({
      loading: true,
    });
    validateFields()
      .then((values) => {
        // console.log(values);
        fetchHandler(addFirmware, {
          ...fileNameJsonParmas,
          // firmwareFileName: values.file[0].response.fileIdList[0],
          // userId: sessionStorage.getItem('name'),
          info: values.info,
        }).then((res) => {
          this.setState({
            loading: false,
          });
          if (res && res.code === "success") {
            message.success("固件版本上传成功");
            this.props.refresh();
            this.props.onCancel();
            this.props.jumpToDetail();
          }
        });
      })
      .catch(() => {
        // console.log(values);
        this.setState({
          loading: false,
        });
      });
  };

  // 修改版本富文本信息
  changeVersionInfo = (changeValue) => {
    console.log(changeValue);
    const { setFieldsValue } = this.formRef.current;
    setFieldsValue({ info: changeValue });
  };

  handleUploadChange = (fileList) => {
    this.formRef.current.setFieldsValue({
      file: fileList,
    });
  };

  render() {
    return (
      <Modal
        width={800}
        title="上传版本"
        visible={this.props.visible}
        onCancel={this.props.onCancel}
        onOk={this.handleSubmit}
        okButtonProps={{
          loading: this.state.loading,
        }}>
        <Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} ref={this.formRef}>
          <Form.Item
            label="选择文件"
            name="file"
            rules={[{ required: true, message: "请选择文件" }]}
            style={{ overflow: "inherit" }}>
            <UploadGeneral
              uploadPath="/uploadFile.do"
              types={["bin"]}
              valueChange={this.handleUploadChange}
              uploadProps={{
                progress: {
                  strokeWidth: 3,
                  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
                },
                data: (file) => {
                  const fileName = file.name;
                  const dataArr = fileName.split("_");
                  return {
                    storeName: "firmware_charing_upload",
                    filePath: `/${dataArr[3]}/${fileName}`,
                    frameType: dataArr[3],
                    frameWork: dataArr[6],
                  };
                },
                beforeUpload: (file) => {
                  console.log("beforeUpload");
                  const fileName = file.name;
                  const dataArr = fileName.split("_");
                  if (dataArr.length < 8) {
                    message.error("文件命名格式错误！");
                    file.status = "error";
                    return false;
                  } else {
                    console.log(dataArr[7]);
                    console.log(dataArr[7].split("."));
                    fileNameJsonParmas["company"] = dataArr[0];
                    fileNameJsonParmas["acDc"] = dataArr[1];
                    fileNameJsonParmas["cmosType"] = dataArr[2];
                    fileNameJsonParmas["frameType"] = dataArr[3];
                    fileNameJsonParmas["stubType"] = dataArr[4];
                    fileNameJsonParmas["date"] = dataArr[5];
                    fileNameJsonParmas["frameWork"] = dataArr[6];
                    fileNameJsonParmas["updateCompay"] = dataArr[7].split(".")[0];
                    fileNameJsonParmas["firmwareFileName"] = fileName;

                    // props.data.filePath = "chargepoint/firmware/" + dataArr[3] + "/" + fileName;
                  }
                },
              }}
              cover>
              <Button type="primary">点击上传</Button>
            </UploadGeneral>
          </Form.Item>
          <Form.Item
            label="版本说明"
            name="info"
            style={{ overflow: "inherit" }}
            rules={[
              { required: true, message: "请输入不少于20个字数的版本说明" },
              { min: 25, message: "请输入不少于20个字数的版本说明" },
            ]}>
            <RichEditor
              onChange={(changedValue) => {
                this.changeVersionInfo(changedValue);
              }}
              className="upload-version-class"
              ref={(ref) => (this.editRef = ref)}
              controls={[
                "undo",
                "redo",
                "separator",
                "font-size",
                "line-height",
                "letter-spacing",
                "separator",
                "bold",
                "text-color",
                // "media",
                // 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
                // 'superscript', 'subscript', 'remove-styles', 'emoji', 'separator',
                // 'text-indent', 'text-align', 'separator',
                // 'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator',
                "link",
                "separator",
                "hr",
                "separator",
                // 'separator',
                // 'clear'
              ]}
            />
            {/* <Input.TextArea placeholder="字数不少于20字"></Input.TextArea> */}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default UploadModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/uploadModal.js